import { render, staticRenderFns } from "./switchRadio.vue?vue&type=template&id=b0d99ff0&"
import script from "./switchRadio.vue?vue&type=script&lang=js&"
export * from "./switchRadio.vue?vue&type=script&lang=js&"
import style0 from "./switchRadio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports